import { alertMessageSelector } from "../../../hooks/store/getters";
import styles from "./AlertDismissable.module.css";
import { useAppStore } from "../../../hooks/store/useAppStore";
import { setAlertMessageSelector } from "../../../hooks/store/setters";
import Toast from 'react-bootstrap/Toast'
import logo from "../../../images/logo.svg"

  const AlertDismissible = () => {
    const alertMessage = useAppStore(alertMessageSelector); 
    const setAlertMessage = useAppStore(setAlertMessageSelector);

    if(!alertMessage) return null;

    return (
      <Toast className={styles.container} 
        position="top-center" 
        show={alertMessage} 
        delay={3000} 
        autohide
        onClose={() => setAlertMessage("")} 
      >
        <Toast.Header>
          <img
            src={logo}
            className="rounded me-2"
            alt=""
            height="30px"
            width="30px"
          />
          <strong className="ml-1 mr-auto">My Hometown Tour</strong>
        </Toast.Header>
        <Toast.Body>{alertMessage}</Toast.Body>
      </Toast>
    );
  }
  
  export default AlertDismissible;
